import { Trans, useTranslation } from 'i18n';
import { Typography } from 'ui';

import { guideImages } from '../../data';
import { EvidenceFeedback } from '../EvidenceFeedback/EvidenceFeedback';

export const PartTwo = () => {
  const { t } = useTranslation('features');

  return (
    <>
      <Typography>
        <Trans
          namespace="features"
          i18nKey="helpGuides.aiBriquette.partTwo.analysisInstruction"
          components={{
            bold: <Typography component="span" fontWeight="bold" />,
          }}
        />
      </Typography>
      <Typography>{t('helpGuides.aiBriquette.partTwo.intro')}</Typography>
      <EvidenceFeedback
        src={guideImages.goodBriquetteOne}
        caption={t('helpGuides.aiBriquette.partTwo.captions.goodDistance')}
        variant="yes"
      />
      <EvidenceFeedback
        src={guideImages.goodBriquetteTwo}
        caption={t('helpGuides.aiBriquette.partTwo.captions.okDistance')}
        variant="yes"
      />
      <EvidenceFeedback
        src={guideImages.goodBriquetteThree}
        caption={t('helpGuides.aiBriquette.partTwo.captions.noMarkingsVisible')}
        variant="yes"
      />
      <EvidenceFeedback
        src={guideImages.badBriquetteOne}
        caption={t('helpGuides.aiBriquette.partTwo.captions.tooDirty')}
        variant="no"
      />
      <EvidenceFeedback
        src={guideImages.badBriquetteTwo}
        caption={t('helpGuides.aiBriquette.partTwo.captions.tooShredded')}
        variant="no"
      />
      <EvidenceFeedback
        src={guideImages.badBriquetteThree}
        caption={t('helpGuides.aiBriquette.partTwo.captions.markingsVisible')}
        variant="no"
      />
    </>
  );
};
